import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import AuthUserContext from './context';
import { withFirebase } from '../utils/FirebaseInterface';

const withAuthorization = condition => Component => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        authUser => {
          console.log('authUser() ',authUser);    
          if (!condition(authUser)) {
            this.props.history.push("/login");
          }
        },
        () => this.props.history.push("/login"),
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      console.log('withAuthorization() ..');
      return (
        <AuthUserContext.Consumer>
          {authUser =>
            condition(authUser) ? <Component {...this.props} /> : null
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return compose(
    withRouter,
    withFirebase,
  )(WithAuthorization);
};

export default withAuthorization;
